import type { NavigateFunction } from "react-router-dom";

/** Route state a setup task screen receives when it is opened from a checklist. */
export type SetupTaskState = {
  fromSetup?: boolean;
  /** Where to send the customer once the task is done, e.g. back to checkout. */
  returnTo?: string;
  /** Route state handed back to `returnTo`. */
  returnState?: unknown;
};

export const readSetupTaskState = (state: unknown): SetupTaskState =>
  state && typeof state === "object" ? (state as SetupTaskState) : {};

/**
 * Leave a finished setup task. A task started from a gate (the installment
 * checkout) goes back to that gate so the customer keeps their booking;
 * otherwise it returns to the dashboard as before.
 */
export function leaveSetupTask(
  navigate: NavigateFunction,
  state: unknown,
  fallback = "/home",
) {
  const { returnTo, returnState } = readSetupTaskState(state);
  if (returnTo) {
    navigate(returnTo, { replace: true, state: returnState ?? null });
    return;
  }
  navigate(fallback);
}
